export const mainAssignee = {
  image: "/landing/avatars/ethan.png",
  online: true,
};
export const secondaryAssignee = {
  image: "/landing/avatars/generic.png",
  online: true,
};
